import { type ParsedTokens } from '@app/client/apiFactory/api.types';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { parseJwt } from './jwt';
import { getUrlParams } from './url';

export const onLoadUrlParams = (callback: (ParsedTokens, redirect?: string) => void): void => {
    const { refresh_token, access_token, redirect } = getUrlParams();
    const deleteParams = {};
    const tokens = {
        refresh_token: '',
        access_token: '',
    };

    const parsedTokens: ParsedTokens = {
        refresh_token: undefined,
        access_token: undefined,
    };
    let storeValues = false;
    if (refresh_token) {
        try {
            parsedTokens.refresh_token = parseJwt(refresh_token);
            tokens.refresh_token = refresh_token;
            deleteParams['refresh_token'] = refresh_token;
            storeValues = true;
        } catch (e) {
            console.error('Invalid refresh token provided'); // eslint-disable-line no-console
        }
    }

    if (access_token) {
        try {
            //Attempt to decode these, if they are not valid do not store them.
            parsedTokens.access_token = parseJwt(access_token);
            tokens.access_token = access_token;
            deleteParams['access_token'] = access_token;
            storeValues = true;
        } catch (e) {
            console.error('Invalid access token'); // eslint-disable-line no-console
        }
    }
    if (redirect) {
        deleteParams['redirect'] = true;
    }

    //Don't manipulate the URL unless we need to.
    if (Object.keys(deleteParams).length) {
        deleteUrlParams(Object.keys(deleteParams));
    }
    if (storeValues) {
        useAuthTokens.setState({ token: tokens });
    }
    callback(parsedTokens, redirect);
};

function deleteUrlParams(keys): void {
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    keys.forEach((key) => {
        urlParams.delete(key);
    });
    window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);
}
